/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type LightbulbIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let LightbulbIcon: NessieFunctionComponent<LightbulbIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.951 1c-3.75 0-6.818 3.02-6.818 6.721 0 1.9.78 3.945 2.094 5.503l.049.05c.39.486 1.558 2.142 1.558 3.262 0 .438.39.828.828.828h4.53c.097 0 .243 0 .34-.049a.867.867 0 00.488-.779c0-.974.974-2.484 1.558-3.263.024-.024.037-.049.049-.073a.252.252 0 01.049-.073c1.266-1.559 2.045-3.604 2.045-5.455C18.77 4.02 15.701 1 11.951 1zm3.36 11.25c-.048.05-.097.098-.097.195-.39.487-1.363 1.9-1.704 3.312H10.44c-.331-1.469-1.4-2.892-1.727-3.327l-.026-.034c0-.03-.018-.041-.044-.057a.271.271 0 01-.053-.04c-1.12-1.266-1.753-3.02-1.753-4.53 0-2.775 2.289-5.064 5.162-5.064 2.825 0 5.163 2.24 5.163 5.065-.05 1.46-.731 3.214-1.851 4.48zM3.77 6.503L.8 4.41a.757.757 0 01-.293-.39c-.049-.146 0-.292.098-.438.194-.243.584-.34.827-.146l2.728 1.9a.698.698 0 00-.049.17c-.012.06-.024.122-.049.17-.048.147-.097.341-.146.536 0 .049-.012.11-.024.17a.955.955 0 00-.024.171s-.05 0-.098-.049zm16.239-.059a.629.629 0 01-.02-.135 8.053 8.053 0 00-.147-.536.697.697 0 01-.049-.17.692.692 0 00-.048-.171l2.825-1.948c.243-.195.633-.098.828.146.097.146.146.292.097.438-.049.146-.098.292-.244.39l-2.97 2.094c-.027.013-.05.026-.07.038a.32.32 0 01-.174.06c0-.08-.015-.147-.028-.206zm3.486 2.446c.146.049.292.097.39.243a.566.566 0 01.097.487.578.578 0 01-.585.487H23.3l-3.36-.584c0-.049.012-.11.024-.17.012-.061.024-.122.024-.17 0-.098.012-.184.025-.269.012-.085.024-.17.024-.268.049-.097.049-.243.049-.34l3.409.584zM19.84 11.08c-.04-.078-.142-.125-.231-.166a2.135 2.135 0 01-.061-.028c-.049.097-.098.194-.098.292-.024.073-.06.158-.097.243-.036.086-.073.17-.097.244-.025.049-.049.11-.073.17-.025.061-.049.122-.073.17l1.899 2.728c.097.146.243.195.39.244h.097c.146 0 .244-.049.341-.098.146-.097.195-.243.243-.39.05-.145 0-.292-.097-.438l-2.143-2.97zM3.915 9.183c-.048-.195-.048-.34-.048-.536 0-.097 0-.243-.05-.34l-3.31.584c-.147.049-.293.097-.39.243-.098.146-.147.293-.098.439a.578.578 0 00.585.487H.7l3.263-.585c0-.097 0-.195-.049-.292zm.487 1.705c0 .146.05.243.098.34.025.05.047.101.068.15.06.14.116.265.224.338.024.048.049.11.073.17.024.061.049.122.073.17l-1.85 2.63c-.098.147-.244.195-.39.244H2.6a.903.903 0 01-.34-.097c-.147-.098-.195-.244-.244-.39-.049-.146 0-.292.097-.438l2.095-2.971a.672.672 0 01.194-.146zm5.699 7.89h3.75c.34 0 .633.34.681.681v2.582c0 .39-.292.681-.681.681h-.633l-.341.39a.6.6 0 01-.487.244h-.828c-.195 0-.341-.098-.487-.244l-.341-.39H10.1a.666.666 0 01-.682-.681v-2.582c0-.39.292-.681.682-.681z"
          />
          <mask maskUnits="userSpaceOnUse" x={0} y={1} width={24} height={23}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.951 1c-3.75 0-6.818 3.02-6.818 6.721 0 1.9.78 3.945 2.094 5.503l.049.05c.39.486 1.558 2.142 1.558 3.262 0 .438.39.828.828.828h4.53c.097 0 .243 0 .34-.049a.867.867 0 00.488-.779c0-.974.974-2.484 1.558-3.263.024-.024.037-.049.049-.073a.252.252 0 01.049-.073c1.266-1.559 2.045-3.604 2.045-5.455C18.77 4.02 15.701 1 11.951 1zm3.36 11.25c-.048.05-.097.098-.097.195-.39.487-1.363 1.9-1.704 3.312H10.44c-.331-1.469-1.4-2.892-1.727-3.327l-.026-.034c0-.03-.018-.041-.044-.057a.271.271 0 01-.053-.04c-1.12-1.266-1.753-3.02-1.753-4.53 0-2.775 2.289-5.064 5.162-5.064 2.825 0 5.163 2.24 5.163 5.065-.05 1.46-.731 3.214-1.851 4.48zM3.77 6.503L.8 4.41a.757.757 0 01-.293-.39c-.049-.146 0-.292.098-.438.194-.243.584-.34.827-.146l2.728 1.9a.698.698 0 00-.049.17c-.012.06-.024.122-.049.17-.048.147-.097.341-.146.536 0 .049-.012.11-.024.17a.955.955 0 00-.024.171s-.05 0-.098-.049zm16.239-.059a.629.629 0 01-.02-.135 8.053 8.053 0 00-.147-.536.697.697 0 01-.049-.17.692.692 0 00-.048-.171l2.825-1.948c.243-.195.633-.098.828.146.097.146.146.292.097.438-.049.146-.098.292-.244.39l-2.97 2.094c-.027.013-.05.026-.07.038a.32.32 0 01-.174.06c0-.08-.015-.147-.028-.206zm3.486 2.446c.146.049.292.097.39.243a.566.566 0 01.097.487.578.578 0 01-.585.487H23.3l-3.36-.584c0-.049.012-.11.024-.17.012-.061.024-.122.024-.17 0-.098.012-.184.025-.269.012-.085.024-.17.024-.268.049-.097.049-.243.049-.34l3.409.584zM19.84 11.08c-.04-.078-.142-.125-.231-.166a2.135 2.135 0 01-.061-.028c-.049.097-.098.194-.098.292-.024.073-.06.158-.097.243-.036.086-.073.17-.097.244-.025.049-.049.11-.073.17-.025.061-.049.122-.073.17l1.899 2.728c.097.146.243.195.39.244h.097c.146 0 .244-.049.341-.098.146-.097.195-.243.243-.39.05-.145 0-.292-.097-.438l-2.143-2.97zM3.915 9.183c-.048-.195-.048-.34-.048-.536 0-.097 0-.243-.05-.34l-3.31.584c-.147.049-.293.097-.39.243-.098.146-.147.293-.098.439a.578.578 0 00.585.487H.7l3.263-.585c0-.097 0-.195-.049-.292zm.487 1.705c0 .146.05.243.098.34.025.05.047.101.068.15.06.14.116.265.224.338.024.048.049.11.073.17.024.061.049.122.073.17l-1.85 2.63c-.098.147-.244.195-.39.244H2.6a.903.903 0 01-.34-.097c-.147-.098-.195-.244-.244-.39-.049-.146 0-.292.097-.438l2.095-2.971a.672.672 0 01.194-.146zm5.699 7.89h3.75c.34 0 .633.34.681.681v2.582c0 .39-.292.681-.681.681h-.633l-.341.39a.6.6 0 01-.487.244h-.828c-.195 0-.341-.098-.487-.244l-.341-.39H10.1a.666.666 0 01-.682-.681v-2.582c0-.39.292-.681.682-.681z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
LightbulbIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  LightbulbIcon = nessiePropCheckerWrapper(LightbulbIcon);
}

export default LightbulbIcon;
